// extracted by mini-css-extract-plugin
module.exports = {"separator":"TeamTab_separator__19e1w","memberName":"TeamTab_memberName__2fn9g"};